export default __webpack_public_path__ + "static/media/stripes-l-top.3289dd56.png";